<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'leaplearner'
    }
  }
}
</script>
<style>
/* 全局reset-start */
blockquote,body,button,dd,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,hr,input,legend,li,ol,p,pre,td,textarea,th,ul {margin:0;padding:0}
h1,h2,h3,h4,h5,h6 {font-size:100%}

address,cite,dfn,em,var {font-style:normal}
code,kbd,pre,samp {font-family:courier new,courier,monospace}
small {font-size:12px}
ol,ul {list-style:none}
a {text-decoration:none}
a:hover {text-decoration:underline}
sup {vertical-align:text-top}
sub {vertical-align:text-bottom}
legend {color:#000}
fieldset,img {border:0}
button,input,select,textarea {font-size:100%}
table {border-collapse:collapse;border-spacing:0}
/* 全局reset-end */

/*清除浮动代码*/
.clearfix:after{clear:both;content:"";visibility:hidden;height:0}
.clearfix{zoom:1}

/*placeholder 样式*/
::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:    #999999;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:    #999999;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
   color:    #999999;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color:    #999999;
}
html,body{
  height: 100% !important;
  width: 100% !important;
}
#app {
  width: 100%;
  height: 100%;
  position: relative;
}
body{
  /*background:blanchedalmond;*/
  /*font-family: "Microsoft YaHei";*/
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
.el-loading-mask{
  background: rgba(0,0,0,.3) 
}

</style>



// WEBPACK FOOTER //
// src/App.vue